module.exports = __webpack_public_path__ + "static/media/developer-resume.29f417f9.pdf";